// Port of api/fuel/app/classes/controller/api/monty/activity/delete.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import LogUserRating from 'offline/model/log/user/rating'
import LogUserCollection from 'offline/model/log/user/collection'
import LogUserInitiated from 'offline/model/log/user/initiated'
import LogUserRegistered from 'offline/model/log/user/registered'
import LogUserPlay from 'offline/model/log/user/play'
import LogUserGroup from 'offline/model/log/user/group'
import LogUserMember from 'offline/model/log/user/member'
import LogUserHindex from 'offline/model/log/user/hindex'
import LogUserListing from 'offline/model/log/user/listing'
import LogUserEdition from 'offline/model/log/user/edition'
import LogUserComment from 'offline/model/log/user/comment'
import LogUserBuddy from 'offline/model/log/user/buddy'
import LogUserBuddies from 'offline/model/log/user/buddies'
import LogUserCollectionStatus from 'offline/model/log/user/collection/status'
import LogUserTag from 'offline/model/log/user/tag'
import LogUserTagAttach from 'offline/model/log/user/tag/attach'

var LOG_MODELS = {}
LOG_MODELS[Constants.LOG_TYPE_USER_RATING] = LogUserRating
LOG_MODELS[Constants.LOG_TYPE_USER_COLLECTION] = LogUserCollection
LOG_MODELS[Constants.LOG_TYPE_USER_INITIATED] = LogUserInitiated
LOG_MODELS[Constants.LOG_TYPE_USER_REGISTERED] = LogUserRegistered
LOG_MODELS[Constants.LOG_TYPE_USER_PLAY] = LogUserPlay
LOG_MODELS[Constants.LOG_TYPE_USER_GROUP] = LogUserGroup
LOG_MODELS[Constants.LOG_TYPE_USER_MEMBER] = LogUserMember
LOG_MODELS[Constants.LOG_TYPE_USER_HINDEX] = LogUserHindex
LOG_MODELS[Constants.LOG_TYPE_USER_LIST] = LogUserListing
LOG_MODELS[Constants.LOG_TYPE_USER_EDITION] = LogUserEdition
LOG_MODELS[Constants.LOG_TYPE_USER_COMMENT] = LogUserComment
LOG_MODELS[Constants.LOG_TYPE_USER_BUDDY] = LogUserBuddy
LOG_MODELS[Constants.LOG_TYPE_USER_BUDDIES] = LogUserBuddies
LOG_MODELS[Constants.LOG_TYPE_USER_COLLECTION_STATUS] = LogUserCollectionStatus
LOG_MODELS[Constants.LOG_TYPE_USER_TAG] = LogUserTag
LOG_MODELS[Constants.LOG_TYPE_USER_TAG_ATTACH] = LogUserTagAttach

export default function(params) {
	var userId = Number(params.sessionUserId || DB.meta('sync_user_id') || 0) || 0
	if (!userId) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	var Model = LOG_MODELS[parseInt(params.type, 10) || 0]
	if (!Model) {
		return Promise.reject({ error: Constants.API_ERROR_NOTFOUND, offline: true })
	}

	var activity = Model.with_id(parseInt(params.id, 10) || 0)
	if (!activity) {
		return Promise.reject({ error: Constants.API_ERROR_NOTFOUND, offline: true })
	}

	if ((activity.get_user_id ? activity.get_user_id() : 0) !== userId) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	DB.run('DELETE FROM ' + Model.schema_table() + ' WHERE ' + Model.schema_key() + ' = ?', [activity.get_id()])
	DB.run('UPDATE user SET user_data_version = ? WHERE user_id = ?', [
		Math.floor(Date.now() / 1000),
		userId
	])

	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: {
				id: activity.get_id()
			}
		}
	})
}
